import React from 'react';
import { motion } from 'framer-motion';
import { useParams, Link } from 'react-router-dom';
import { MapPin, Globe, Users, Music, Send } from 'lucide-react';
export function PublicVenueProfilePage() {
  const {
    venueSlug
  } = useParams();
  return <div className="min-h-screen bg-background text-textMain" data-id="element-6945">
      {/* Minimal Header */}
      <header className="h-16 border-b border-border flex items-center justify-between px-6 bg-surface/50 backdrop-blur sticky top-0 z-50" data-id="element-6946">
        <Link to="/" className="flex items-center gap-2" data-id="element-6947">
          <span className="text-xl font-bold" data-id="element-6948">Booker</span>
          <div className="w-1.5 h-1.5 rounded-full bg-primary" data-id="element-6949"></div>
        </Link>
        <div className="text-sm text-textMuted" data-id="element-6950">Powered by Booker</div>
      </header>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="max-w-5xl mx-auto px-6 py-12" data-id="element-6951">
        {/* Hero Section */}
        <div className="bg-surface border border-border rounded-2xl p-8 mb-12 relative overflow-hidden" data-id="element-6952">
          <div className="absolute top-0 right-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-6953"></div>

          <div className="relative z-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6" data-id="element-6954">
            <div data-id="element-6955">
              <h1 className="text-4xl font-bold mb-2" data-id="element-6956">The Empty Bottle</h1>
              <div className="flex flex-wrap items-center gap-4 text-sm text-textMuted" data-id="element-6957">
                <div className="flex items-center gap-1.5" data-id="element-6958">
                  <MapPin className="w-4 h-4" data-id="element-6959" />
                  1035 N Western Ave, Chicago, IL
                </div>
                <div className="flex items-center gap-1.5" data-id="element-6960">
                  <Globe className="w-4 h-4" data-id="element-6961" />
                  emptybottle.com
                </div>
              </div>
            </div>
            <button className="px-6 py-3 bg-primary text-background rounded-xl font-medium hover:bg-primaryHover transition-colors flex items-center gap-2 shrink-0" data-id="element-6962">
              <Send className="w-4 h-4" data-id="element-6963" /> Submit Booking Inquiry
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-6964">
          {/* Main Content */}
          <div className="md:col-span-2 space-y-8" data-id="element-6965">
            <section data-id="element-6966">
              <h2 className="text-2xl font-bold mb-4" data-id="element-6967">Rooms & Capacity</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-6968">
                <div className="bg-surface border border-border rounded-xl p-6" data-id="element-6969">
                  <h3 className="text-lg font-bold mb-1" data-id="element-6970">Main Room</h3>
                  <p className="text-sm text-textMuted mb-4" data-id="element-6971">
                    Primary performance space
                  </p>
                  <div className="space-y-2 text-sm" data-id="element-6972">
                    <div className="flex justify-between" data-id="element-6973">
                      <span className="text-textMuted" data-id="element-6974">Capacity</span>
                      <span className="font-medium" data-id="element-6975">400 Standing</span>
                    </div>
                    <div className="flex justify-between" data-id="element-6976">
                      <span className="text-textMuted" data-id="element-6977">Age Policy</span>
                      <span className="font-medium" data-id="element-6978">21+</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section data-id="element-6979">
              <h2 className="text-2xl font-bold mb-4" data-id="element-6980">
                Programming Preferences
              </h2>
              <div className="bg-surface border border-border rounded-xl p-6" data-id="element-6981">
                <div className="space-y-6" data-id="element-6982">
                  <div data-id="element-6983">
                    <h4 className="text-sm font-medium text-textMuted mb-2" data-id="element-6984">
                      Primary Genres
                    </h4>
                    <div className="flex flex-wrap gap-2" data-id="element-6985">
                      <span className="px-3 py-1 bg-background border border-border rounded-lg text-sm" data-id="element-6986">
                        Indie Rock
                      </span>
                      <span className="px-3 py-1 bg-background border border-border rounded-lg text-sm" data-id="element-6987">
                        Alternative
                      </span>
                      <span className="px-3 py-1 bg-background border border-border rounded-lg text-sm" data-id="element-6988">
                        Punk
                      </span>
                      <span className="px-3 py-1 bg-background border border-border rounded-lg text-sm" data-id="element-6989">
                        Post-Punk
                      </span>
                    </div>
                  </div>
                  <div data-id="element-6990">
                    <h4 className="text-sm font-medium text-textMuted mb-2" data-id="element-6991">
                      Booking Notes
                    </h4>
                    <p className="text-sm leading-relaxed" data-id="element-6992">
                      We primarily book original touring acts and strong local
                      support. We do not book cover bands or tribute acts. All
                      shows are 21+ unless otherwise noted.
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>

          {/* Sidebar */}
          <div className="space-y-6" data-id="element-6993">
            <div className="bg-surface border border-border rounded-xl p-6" data-id="element-6994">
              <h3 className="font-semibold mb-4" data-id="element-6995">Contact Info</h3>
              <div className="space-y-4 text-sm" data-id="element-6996">
                <div data-id="element-6997">
                  <div className="font-medium" data-id="element-6998">Booking</div>
                  <a href="mailto:booking@emptybottle.com" className="text-primary hover:underline" data-id="element-6999">
                    booking@emptybottle.com
                  </a>
                </div>
                <div data-id="element-7000">
                  <div className="font-medium" data-id="element-7001">Production</div>
                  <a href="mailto:production@emptybottle.com" className="text-primary hover:underline" data-id="element-7002">
                    production@emptybottle.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}